import { inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class AppCookieService {
    private cookieService = inject(CookieService);
  constructor() {}

  get(name: string): string | null {
    const value = this.cookieService.get(name);
    return value || null;
  }

  set(name: string, value: string, days: number = 1, path: string = '/', secure: boolean = true, sameSite: 'Lax' | 'Strict' | 'None' = 'Lax') {
    this.cookieService.set(name, value, days, path, undefined, secure, sameSite);
  }

  delete(name: string, path: string = '/') {
    this.cookieService.delete(name, path);
  }
}
